import React from "react";
import PropTypes from "prop-types";
import TrackBoxes from "../Components/Elements/TrackBoxes";
import TrackComment from "../Components/Elements/TrackComment";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

class EndlessScrollContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            hasMore: false,
            type: this.props.type,
            filter: this.props.filter,
            items: [],
            isLoading: false,
            initialLoading: true
        };
        this.scrollThreshold = 200; // pixels from bottom to trigger load
        this.scrollTimeout = null;
    }

    componentDidMount() {
        this.fetch();
        window.addEventListener("scroll", this.handleScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
    }

    handleScroll = () => {
        if (this.state.isLoading || !this.state.hasMore) {
            return;
        }

        // Throttle scroll handler
        if (this.scrollTimeout) {
            return;
        }

        this.scrollTimeout = setTimeout(() => {
            this.scrollTimeout = null;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;

            // Check if user is near the bottom of the page
            if (scrollTop + windowHeight >= documentHeight - this.scrollThreshold) {
                this.fetch();
            }
        }, 100);
    };

    fetch = () => {
        if (this.state.isLoading) {
            return;
        }

        this.setState({ isLoading: true });
        this.props.request(this.state.filter, this.state.page).then(({ data }) => {
            const hasMore = data.length === 30;
            const items = this.state.items;
            data.map((t) => items.push(t));
            this.setState({
                items,
                page: this.state.page + 1,
                hasMore,
                isLoading: false,
                initialLoading: false
            });
        }).catch(() => {
            this.setState({ isLoading: false, initialLoading: false });
        });
    };

    render = () => {
        const items = this.state.items;
        const { type, hasMore, isLoading, initialLoading } = this.state;
        const { loading } = this.props;

        // Show skeleton loading on initial load or when parent container is loading
        if ((initialLoading || isLoading || loading) && items.length === 0) {
            if (type === "track") {
                return (
                    <SkeletonTheme color="#f3f3f3" highlightColor="#ecebeb">
                        <Skeleton count={1} height={60} style={{ marginBottom: "40px" }} />
                    </SkeletonTheme>
                );
            }
            return (
                <SkeletonTheme color="#f3f3f3" highlightColor="#ecebeb">
                    <Skeleton count={1} />
                </SkeletonTheme>
            );
        }

        if (!loading && items.length === 0 && !initialLoading) {
            return null;
        }

        return (
            <React.Fragment>
                {!loading && items.length && this.props.track && (
                    <div className="totd-header">
                        <h3>
                            Comments for &ldquo;<span>{this.props.track.title}</span>&rdquo; by <span>{this.props.track.artist}</span>
                        </h3>
                    </div>
                )}
                {items && type === "track" && <TrackBoxes tracks={items} />}
                {items &&
                    (type === "comment" || type === "comment-search") &&
                    items.map((comment) => (
                        <div key={comment.id}>
                            <TrackComment addRe={this.state.addRe} comment={comment} type={type} highlight={this.state.filter} />
                        </div>
                    ))}

                {!loading && (type === "comment" || type === "comment-search") && items.length === 0 && <div>Nothing found, please try again.</div>}

                {(isLoading || loading) && hasMore && (
                    <Row>
                        <Col xs={12} className="col-text-center" style={{ padding: "20px 0" }}>
                            <Spinner animation="border" size="sm" /> Loading {items.length > 0 ? "more" : ""}...
                        </Col>
                    </Row>
                )}
            </React.Fragment>
        );
    };
}

EndlessScrollContainer.propTypes = {
    filter: PropTypes.string,
};
EndlessScrollContainer.defaultProps = {};
export default EndlessScrollContainer;

